import React from 'react'
import './upgrade-label.css'
import { Button } from 'react-bootstrap'
import { AppUseSelector } from '../../../redux/hooks'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { PlanChangeLink } from '../../../utils/constant'
import { serverText } from 'i18n/serverText'

const UpgradeLabel = () => {
  const { t } = useTranslation('landing')
  const { CTAMessage } = AppUseSelector(({ story }) => story)
  const navigate = useNavigate()
  const ctaKey = CTAMessage?.key ? `landing:home.cta.${CTAMessage.key}` : null
  const text = (field: 'title' | 'message' | 'button', english: string) => serverText(ctaKey && `${ctaKey}.${field}`, english)

  const handleClick = () => {
    // Prefer backend-configured link; fall back to in-app settings plan page
    const target = CTAMessage?.link || PlanChangeLink
    navigate(target)
  }

  return (
    <div className='upgrade_box_main_div'>
      <div className='left_div'>
        <div className='img_box'>
          <img alt={t('upgradeLabel.imageAlt')} src={'/images/welcome-img.svg'} />
        </div>
        <div className='upgrade_contains'>
          <h5>{text('title', CTAMessage?.titleMessage)}</h5>
          <p>{text('message', CTAMessage?.message)}</p>
        </div>
      </div>
      <div className='right_div'>
        <Button
          type='button'
          className='common_btn mob_w_100'
          onClick={handleClick}
        >
          {text('button', CTAMessage?.button)}
        </Button>
      </div>
    </div>
  )
}

export default UpgradeLabel
